import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-content-field',
  templateUrl: './content-field.component.html',
  styleUrls: ['./content-field.component.scss']
})
export class ContentFieldComponent {

  @Input() label: string;
  @Input() content: string | number;
  @Input() isAccent = false;
  @Input() isEditable = false;

  @Output('editClick') editButtonClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {
  }

  editIconClicked() {
    this.editButtonClicked.emit(true);
  }

}
